import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import TableShippingProvidersComponent from '../components/TableShippingProvidersComponent';
import TableProvidersComponent from '../components/TableProvidersComponent';
import { validateSession } from  '../utils/functions';
var config = process.env;

class ProviderPage extends Component {

	constructor(){
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole
        }
	}

	async componentDidMount() {
        let role = await validateSession(true)
        this.setState({ checked: true, role:  role});
    }
    
	render() {
        if (!this.state.checked) {
            return (<div></div>);
        } else {
            return (  
                <div class="container-fluid">
                    <div class="row">
                        <SidebarComponent itemSelected={10} role={this.state.role}/>
                        <main class="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                            <NavbarComponent role={this.state.role} />
                            <div className="main-content-container container-fluid px-4 mb-4">
                                <HeaderComponent title="Dashboard" subtitle="Proveedores de envios"/>
                                <TableShippingProvidersComponent />
                                <HeaderComponent subtitle="Proveedores de mercadería"/>
                                <TableProvidersComponent />
                            </div>
                        </main>
                    </div>
                </div>
            );
        }
    }
}

export default ProviderPage;
